import { getLoggedInUserType } from '@/helpers/coOwnerSidebarMenu';

const USERTYPE_ASSET_MANAGER = 'usertype21';

export function isAssetManagerUserType(userType) {
    const resolved =
        userType != null && userType !== ''
            ? String(userType).trim().toLowerCase()
            : getLoggedInUserType();
    return resolved === USERTYPE_ASSET_MANAGER;
}

/**
 * Top-level sidebar row that only groups categoryModules (e.g. "Assets") — not a navigable route.
 */
export function isAssetManagerRootGroupParent(module) {
    if (!module || !isAssetManagerUserType()) {
        return false;
    }

    const hasCategories =
        Array.isArray(module.categoryModules) && module.categoryModules.length > 0;

    return hasCategories && !module.subModules;
}

/**
 * Whether a sidebar row should render a vue-feather icon (Asset Manager grouping parents are text-only).
 */
export function shouldShowSidebarMenuIcon(module, context = {}) {
    if (!module) {
        return false;
    }

    if (!isAssetManagerUserType()) {
        return true;
    }

    const level = context.level || 'item';
    if (level === 'root' && isAssetManagerRootGroupParent(module)) {
        return false;
    }

    return true;
}

export function rootGroupParentLiClass(module) {
    return isAssetManagerRootGroupParent(module) ? 'sidebar-group-parent' : '';
}
